export const REPLAY_MASK_CLASS = 'sentry-mask';

export const REPLAY_BLOCK_CLASS = 'sentry-block';

export const REPLAY_MASK_SELECTORS = [
	`.${REPLAY_MASK_CLASS}`,
	'[data-sentry-mask]',
	'[autocomplete="one-time-code"]',
];

export const REPLAY_BLOCK_SELECTORS = [`.${REPLAY_BLOCK_CLASS}`, '[data-sentry-block]'];
